<svg class="{{class}}">
    <use attr.xlink:href="assets/svg/icon-sprite.svg#{{icons}}"></use>
</svg>
